import Process from '../reducer/process';
import General from '../reducer/general';
import { combineReducers } from 'redux';

const CombineReducers = combineReducers({
    general: General,
    process: Process
});

export default CombineReducers;